export const ICON_STYLES = {
  ml: "5px",
  color: "primaryTwo.500",
  h: "20px",
  w: "20px",
  cursor: "pointer",
  fontSize: "16px"
};

export const WARN_ICON_STYLES = {
  ...ICON_STYLES,
  color: "primary.900"
};

export const PRODUCT_NAME_STYLE = "h5";
export const LABEL_TEXT_STYLE = "body2";
export const VALUE_TEXT_STYLE = "body2semibold";
